import { createAction, props, union } from '@ngrx/store';

import { CorporateReportStatus } from '../constants';

export const setStatus = createAction(
  '[StatusActions] SetStatus',
  props<{ corporateId: string; dateRange: string; status: CorporateReportStatus }>()
);

const all = union({ setStatus });

export type ActionsUnion = typeof all;
